import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import TextCard from "../cards/TextCard";
import ErrorTextCard from "../cards/errorTextCard";
import { relative } from "path";

const style = {
  // position: "fixed",//"absolute" as "absolute",
  // top: "40%",
  // left: "50%",
  // transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const Item = styled(Paper)(() => ({
  backgroundColor: "#fff",
  textAlign: "center",
}));

export default function ShowErrorsModal({
  openModal,
  validationMessages,
  firstPartOfTitle,
  boldTitle,
  secondPartOfTitle,
  setOpenModal,
}: any) {
  const [open, setOpen] = React.useState(openModal);
  const [messages, setMessages] = React.useState(validationMessages);
  const handleClose = () => {
    setOpen(false);
    setOpenModal(false);
  };
  React.useEffect(() => {
    setOpen(openModal);
  }, [openModal]);
  React.useEffect(() => {
    setMessages(validationMessages);
  }, [validationMessages]);

  return (
    <div>
      <Modal
        keepMounted
        open={open}
        style={{ height: "maxHeight" }}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <div className="modal-wrapper">
          <div className="modal-block">
            <Box
              sx={style}
              style={{ borderRadius: "6px" }}
              className="ModalCmp textCenter  "
            >
              <ReportProblemIcon
                className="classIcons colorCancel  textCenter marginLeft-10"
                style={{ color: "#E6123D" }}
              />
              <Typography className="textCenter mTop30 mbottom20">
                {firstPartOfTitle}{" "}
                <span className="colorCancel">{boldTitle}</span>{" "}
                {secondPartOfTitle}
              </Typography>
              <Grid className="contentT">
                <ErrorTextCard inputMessages={messages} bgColor="#fff" />
              </Grid>
              <Grid container spacing={2} columns={16} className="mTop20">
                <Button
                  fullWidth
                  className="btnForm DangerDefault  mTop40"
                  onClick={handleClose}
                >
                  متوجه شدم
                </Button>
              </Grid>
            </Box>
          </div>
        </div>
      </Modal>
    </div>
  );
}
